/**
 * CheckpointStackIcon — Mi6 custom glyph: stacked CP gates / checkpoint rings
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function CheckpointStackIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Vertical spine / axis */}
      <line x1="40" y1="10" x2="40" y2="70" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      {/* CP gate rings — stacked ellipses along the spine */}
      {/* CP gate 1 — top (largest) */}
      <ellipse cx="40" cy="18" rx="22" ry="6" stroke="currentColor" strokeWidth="1.5" />
      {/* CP gate 2 */}
      <ellipse cx="40" cy="31" rx="18" ry="5" stroke="currentColor" strokeWidth="1.5" />
      {/* CP gate 3 */}
      <ellipse cx="40" cy="43" rx="14" ry="4" stroke="currentColor" strokeWidth="1.5" />
      {/* CP gate 4 */}
      <ellipse cx="40" cy="53" rx="10" ry="3" stroke="currentColor" strokeWidth="1.5" />
      {/* CP gate 5 — bottom (smallest) */}
      <ellipse cx="40" cy="62" rx="6" ry="2.5" stroke="currentColor" strokeWidth="1.5" />
      {/* Directional arrow at bottom */}
      <polyline points="36,68 40,73 44,68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
